module.exports = __webpack_public_path__ + "img/2kimportmenu.25226cd4.png";